import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../_services/game-mode.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-class-select',
  templateUrl: './class-select.component.html',
  styleUrls: ['./class-select.component.scss']
})
export class ClassSelectComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';
  classes: any[] = [];

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    this.gameModeService.availableClasses$
      .pipe(takeUntil(this.destroy$))
      .subscribe(classes => this.classes = classes);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectClass(cls: any): void {
    this.gameModeService.selectClassAndLoadStudents(cls.id);
  }

  goBack(): void {
    this.gameModeService.closeGame();
  }
}
